module.exports = __webpack_public_path__ + "img/Romantikk_Litt_om_spraaket1.661e6606.jpg";